import "./styles.css";
import { body } from "../../../text/story-transition";
import GamePage from "../game-page/game-page";
import { useAppSelector } from "../../../redux/store";

import {
  selectIsSolo,
  selectGameSettings,
  selectPlayerCurrentSubmission,
  selectPlayerCurrentStory,
} from "../../../redux/selectors";
import { useTranslation } from "react-i18next";
import StoryTransitionRow from "./story-transition-row";
import StoryTransitions from "./story-transitions";
import { numberString } from "../character-submit/useCharacterSubmit";

type Props = {
  deadline: number;
};

const bodies = [body.part1, body.partX, body.partEnd];
const bodiesSolo = [body.part1Solo, body.partXSolo, body.partEndSolo];

const StoryTransition = ({ deadline }: Props) => {
  const gameSettings = useAppSelector(selectGameSettings);
  const currentSubmission = useAppSelector(selectPlayerCurrentSubmission);
  const currentStory = useAppSelector(selectPlayerCurrentStory);
  let isSolo = useAppSelector(selectIsSolo);

  const submissionIndex = currentSubmission?.index as number;

  const { t } = useTranslation(["common"]);

  function partMap(index: number, numSwitches: number) {
    if (index === 0) {
      return t("label.beginning", { ns: "common" });
    } else if (index === numSwitches - 1) {
      return t("label.end", { ns: "common" });
    } else {
      return `${t("label.part", { ns: "common" })} ${numberString(index + 1)}`;
    }
  }

  function getBody() {
    if (submissionIndex === 0) {
      return isSolo ? bodiesSolo[0] : bodies[0];
    } else if (submissionIndex === gameSettings.num_switches - 1) {
      return isSolo ? bodiesSolo[2] : bodies[2];
    } else {
      return isSolo ? bodiesSolo[1] : bodies[1];
    }
  }

  function getHeader() {
    return partMap(submissionIndex, gameSettings.num_switches);
  }

  return (
    <GamePage titles={[getHeader()]} hideAvatar>
      <StoryTransitions deadline={deadline} fast={!!gameSettings.solo_writing}>
        <StoryTransitionRow
          text={getBody()(
            submissionIndex,
            gameSettings.num_switches,
            currentStory?.meta.index ?? 0
          )}
        />

        <StoryTransitionRow
          text={
            isSolo
              ? body.charactersSolo(currentStory?.characters)
              : body.characters(currentStory?.characters)
          }
        />

        {(gameSettings.solo_writing ||
          gameSettings.forced_prompts) && (
            <StoryTransitionRow
              text={body.prompt(
                currentSubmission,
                gameSettings.multi_prompt ||
                !!gameSettings.solo_writing
              )}
            />
          )}

        {!isSolo && (
          <StoryTransitionRow
            text={body.mature(
              currentStory?.settings.mature ? "18+" : "ALL AGES"
            )}
          />
        )}
      </StoryTransitions>

      {/*</div>*/}
    </GamePage>
  );
};

export default StoryTransition;
